import { UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';
import { OptionalAnchor } from '../../../../../common/components/OptionalAnchor';

export interface IAboutBuildingProps {
  buildingInfo?: string;
  link?: string | null;
  name?: string;
  linkTarget?: string;
  onLinkClick(): void;
  similarOffersCount?: string | null;
}

export function AboutBuilding({ name, buildingInfo, link, linkTarget, onLinkClick }: IAboutBuildingProps) {
  const handleLinkClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();

      onLinkClick();
    },
    [onLinkClick],
  );

  return (
    <div className={styles['container']}>
      {name && (
        <OptionalAnchor
          href={link}
          rel="noopener"
          target={linkTarget}
          className={styles['name']}
          onAnchorClick={handleLinkClick}
        >
          <UIText2 color={link ? 'primary_100' : undefined}>{name}</UIText2>
        </OptionalAnchor>
      )}
      {buildingInfo && (
        <UIText2 display="block" color="gray60_100">
          {buildingInfo}
        </UIText2>
      )}
    </div>
  );
}
